<template>
  <span
    :class="computedWrapperClasses"
   
    role="status"
    aria-live="polite"
  >
    <span
      :class="computedSpinnerClasses"
      aria-hidden="true"
    />
    <span class="sr-only">{{ computedLabel }}</span>
  </span>
</template>

<script setup lang="ts">
import type { SpinnerSize, SpinnerVariant } from './types'

const props = withDefaults(defineProps<{
  label?: string
  size?: SpinnerSize
  variant?: SpinnerVariant
}>(), {
  size: 'md',
  variant: 'default',
})

const { t } = useI18n()

const computedLabel = computed(() => props.label ?? t('label'))

const computedWrapperClasses = computed(() => ([
  'inline-block outline-gray-200 rounded-full box-border',
  {
    'size-6 outline-2 -outline-offset-3': props.size === 'sm',
    'size-8 outline-4 -outline-offset-4': props.size === 'md',
    'size-12 outline-6 -outline-offset-6': props.size === 'lg',
  },
]))

const computedSpinnerClasses = computed(() => ([
  'block border-transparent rounded-full inline-block box-border animate-spin [animation-duration:500ms]',
  {
    'size-6 border-3': props.size === 'sm',
    'size-8 border-4': props.size === 'md',
    'size-12 border-6': props.size === 'lg',
    'border-b-primary-950': props.variant === 'default',
    'border-b-secondary': props.variant === 'highlight',
  },
]))
</script>

<i18n lang="json">
  {
    "en": {
      "label": "Loading"
    },
    "fr": {
      "label": "Chargement"
    }
  }
</i18n>
